var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * 
 * @file Helper for the box file API
 * @author Box
 */

import Item from './Item';
import { findMissingProperties, fillMissingProperties } from '../util/fields';
import { getTypedFileId } from '../util/file';
import { FIELD_DOWNLOAD_URL, CACHE_PREFIX_FILE, X_REP_HINTS } from '../constants';
import { getBadItemError, getBadPermissionsError } from '../util/error';

var File = function (_Item) {
    _inherits(File, _Item);

    function File() {
        _classCallCheck(this, File);

        return _possibleConstructorReturn(this, (File.__proto__ || Object.getPrototypeOf(File)).apply(this, arguments));
    }

    _createClass(File, [{
        key: 'getCacheKey',

        /**
         * Creates a key for the cache
         *
         * @param {string} id - Folder id
         * @return {string} key
         */
        value: function getCacheKey(id) {
            return '' + CACHE_PREFIX_FILE + id;
        }

        /**
         * API URL for files
         *
         * @param {string} [id] - Optional file id
         * @return {string} base url for files
         */

    }, {
        key: 'getUrl',
        value: function getUrl(id) {
            var suffix = id ? '/' + id : '';
            return this.getBaseApiUrl() + '/files' + suffix;
        }

        /**
         * API for getting download URL for files
         *
         * @param {string} id - File id
         * @param {Function} successCallback - Success callback
         * @param {Function} errorCallback - Error callback
         * @return {void}
         */

    }, {
        key: 'getDownloadUrl',
        value: function getDownloadUrl(id, successCallback, errorCallback) {
            var _this2 = this;

            this.successCallback = successCallback;
            this.errorCallback = errorCallback;
            return this.xhr.get({
                url: this.getUrl(id),
                params: {
                    fields: FIELD_DOWNLOAD_URL
                }
            }).then(function (_ref) {
                var data = _ref.data;

                _this2.successHandler(data[FIELD_DOWNLOAD_URL]);
            }).catch(this.errorHandler);
        }

        /**
         * API for setting the description of a file
         *
         * @param {BoxItem} file - File object for which we are changing the description
         * @param {string} description - New file description
         * @param {Function} successCallback - Success callback
         * @param {Function} errorCallback - Error callback
         * @return {Promise}
         */

    }, {
        key: 'setFileDescription',
        value: function setFileDescription(file, description, successCallback, errorCallback) {
            var _this3 = this;

            var id = file.id,
                permissions = file.permissions;


            if (!id || !permissions) {
                errorCallback(getBadItemError());
                return Promise.reject();
            }

            if (!permissions.can_rename) {
                errorCallback(getBadPermissionsError());
                return Promise.reject();
            }

            return this.xhr.put({
                id: getTypedFileId(id),
                url: this.getUrl(id),
                data: { description: description }
            }).then(function (_ref2) {
                var data = _ref2.data;

                if (!_this3.isDestroyed()) {
                    var updatedFile = _this3.merge(_this3.getCacheKey(id), 'description', data.description);
                    successCallback(updatedFile);
                }
            }).catch(function () {
                if (!_this3.isDestroyed()) {
                    var originalFile = _this3.merge(_this3.getCacheKey(id), 'description', file.description);
                    errorCallback(originalFile);
                }
            });
        }

        /**
         * Gets a box file
         *
         * @param {string} id - File id
         * @param {Function} successCallback - Function to call with results
         * @param {Function} errorCallback - Function to call with errors
         * @param {boolean|void} [options.fields] - Optionally include specific fields
         * @param {boolean|void} [options.forceFetch] - Optionally Bypasses the cache
         * @param {boolean|void} [options.refreshCache] - Optionally Updates the cache
         * @return {Promise}
         */

    }, {
        key: 'getFile',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id, successCallback, errorCallback) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

                var cache, key, isCached, file, missingFields, xhrOptions, _ref4, data, dataWithMissingFields;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!this.isDestroyed()) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 2:
                                cache = this.getCache();
                                key = this.getCacheKey(id);
                                isCached = !options.forceFetch && cache.has(key);
                                file = isCached ? cache.get(key) : { id: id };
                                missingFields = findMissingProperties(file, options.fields);
                                xhrOptions = {
                                    id: getTypedFileId(id),
                                    url: this.getUrl(id),
                                    headers: { 'X-Rep-Hints': X_REP_HINTS }
                                };


                                this.successCallback = successCallback;
                                this.errorCallback = errorCallback;

                                // If the file was cached and there are no missing fields
                                // then just return the cached file and optionally refresh
                                // the cache with new data if required

                                if (!(isCached && missingFields.length === 0)) {
                                    _context.next = 15;
                                    break;
                                }

                                successCallback(file);
                                missingFields = options.fields || [];

                                if (options.refreshCache) {
                                    _context.next = 15;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 15:

                                // If there are missing fields to fetch, add it to the params
                                if (missingFields.length > 0) {
                                    xhrOptions.params = {
                                        fields: missingFields.toString()
                                    };
                                }

                                _context.prev = 16;
                                _context.next = 19;
                                return this.xhr.get(xhrOptions);

                            case 19:
                                _ref4 = _context.sent;
                                data = _ref4.data;

                                if (!this.isDestroyed()) {
                                    _context.next = 23;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 23:

                                // Merge fields that were requested but were actually not returned.
                                // This part is mostly useful for metadata.foo.bar fields since the API
                                // returns { metadata: null } instead of { metadata: { foo: { bar: null } } }
                                dataWithMissingFields = fillMissingProperties(data, missingFields);

                                // Cache check is again done since this code is executed async

                                if (cache.has(key)) {
                                    cache.merge(key, dataWithMissingFields);
                                } else {
                                    // If there was nothing in the cache
                                    cache.set(key, dataWithMissingFields);
                                }

                                this.successHandler(cache.get(key));
                                _context.next = 31;
                                break;

                            case 28:
                                _context.prev = 28;
                                _context.t0 = _context['catch'](16);

                                this.errorHandler(_context.t0);

                            case 31:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[16, 28]]);
            }));

            function getFile(_x, _x2, _x3) {
                return _ref3.apply(this, arguments);
            }

            return getFile;
        }()
    }]);

    return File;
}(Item);

export default File;